// extracted by mini-css-extract-plugin
export default {"values":"Values_values__KR4R9","values__inner":"Values_values__inner__lbg4N","values__inner_top":"Values_values__inner_top__Y740Q"};